import getCorrelationId from '../helpers/getCorrelationId'
import shajs from 'sha.js'

const correlationId = getCorrelationId()

export const formViewed = (stepName = '', stepNumber = 1) => {
  try {
    // eslint-disable-next-line no-undef
    tagular('beam', 'FormViewed', {
      '@type': 'redventures.usertracking.v3.FormViewed',
      correlationId,
      formContext: {
        formType: 'ApprovalOdds',
        formName: 'ApprovalOdds',
        formId: 'ao-form'
      },
      stepContext: {
        stepName,
        stepNumber
      }
    })
  } catch (error) {
    // Do nothing.
  }
}

export const formStarted = () => {
  try {
    // eslint-disable-next-line no-undef
    tagular('beam', 'FormStarted', {
      '@type': 'redventures.usertracking.v3.FormStarted',
      correlationId,
      formContext: {
        formType: 'ApprovalOdds',
        formName: 'ApprovalOdds'
      },
      stepContext: {
        stepName: 'Names',
        stepNumber: 1
      }
    })
  } catch (error) {
    // Do nothing.
  }
}

export const formContinued = (stepName = '', stepNumber = 1) => {
  try {
    // eslint-disable-next-line no-undef
    tagular('beam', 'FormContinued', {
      '@type': 'redventures.usertracking.v3.FormContinued',
      correlationId,
      formContext: {
        formType: 'ApprovalOdds',
        formName: 'ApprovalOdds'
      },
      stepContext: {
        stepName,
        stepNumber
      }
    })
  } catch (error) {
    // Do nothing.
  }
}

export const formSubmitted = () => {
  try {
    // eslint-disable-next-line no-undef
    tagular('beam', 'FormSubmitted', {
      '@type': 'redventures.usertracking.v3.FormSubmitted',
      correlationId,
      formContext: {
        formType: 'ApprovalOdds',
        formName: 'ApprovalOdds',
        formId: 'ApprovalOdds'
      }
    })
  } catch (error) {
    // Do nothing.
  }
}

export const coreIdentify = email => {
  try {
    // eslint-disable-next-line no-undef
    tagular('beam', 'Identify', {
      '@type': 'core.Identify.v1',
      correlationId,
      traits: {
        email
      },
      userId: shajs('sha256')
        .update(email)
        .digest('hex')
    })
  } catch (error) {
    // Do nothing.
  }
}

export const fieldInputted = userInputField => {
  try {
    // eslint-disable-next-line no-undef
    tagular('beam', 'FieldInputted', {
      '@type': 'redventures.usertracking.v3.FieldInputted',
      correlationId,
      formContext: {
        formType: 'ApprovalOdds',
        formName: 'ApprovalOdds'
      },
      userInputField
    })
  } catch (error) {
    // Do nothing.
  }
}

export const loaderViewed = () => {
  try {
    // eslint-disable-next-line no-undef
    tagular('beam', 'ElementViewed', {
      '@type': 'redventures.usertracking.v3.ElementViewed',
      correlationId,
      webElement: {
        elementType: 'Modal',
        location: 'Section',
        name: 'Approval Odds Loading',
        position: 'Top',
        text: 'Loading'
      }
    })
  } catch (error) {
    // Do nothing.
  }
}

export const errorModalViewed = () => {
  try {
    // eslint-disable-next-line no-undef
    tagular('beam', 'ElementViewed', {
      '@type': 'redventures.usertracking.v3.ElementViewed',
      correlationId,
      webElement: {
        elementType: 'Modal',
        location: 'Section',
        name: 'Approval Odds Error Modal',
        position: 'Top',
        text: 'Sorry, we couldnt access your approval odds'
      }
    })
  } catch (error) {
    // Do nothing.
  }
}

export const errorModalRestartClicked = () => {
  try {
    // eslint-disable-next-line no-undef
    tagular('beam', 'ElementClicked', {
      '@type': 'redventures.usertracking.v3.ElementClicked',
      correlationId,
      webElement: {
        elementType: 'Button',
        location: 'Section',
        name: 'Button',
        position: 'Bottom',
        text: 'Start Over'
      }
    })
  } catch (error) {
    // Do nothing.
  }
}

export const closeModalClicked = () => {
  try {
    // eslint-disable-next-line no-undef
    tagular('beam', 'ElementClicked', {
      '@type': 'redventures.usertracking.v3.ElementClicked',
      correlationId,
      webElement: {
        elementType: 'Button',
        location: 'Section',
        name: 'Button',
        position: 'Top',
        text: 'Close'
      }
    })
  } catch (error) {
    // Do nothing.
  }
}
